import Loadable from 'react-loadable';

import {
  INTERNAL_LINKING_REGEX_FOR_REACT_ROUTER,
  SERVICE_LANDING_REGEX_FOR_REACT_ROUTER,
} from '@rover/constants/src/platform/routeData.constants';
import { FooterTheme } from '@rover/kibble/styles';
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import retry from '@rover/rsdk/src/modules/Network/retry';
import Route from '@rover/types/src/Route';

import Loading from '../client/Loading';

const ServiceLandingPage = Loadable({
  loader: () =>
    retry(
      () =>
        import(
          /* webpackChunkName: "ServiceLandingPage" */ '@rover/react-lib/src/pages/landing/ServiceLanding/ServiceLandingPageContainer'
        )
    ),
  loading: Loading,
});

const InternalLinkingPage = Loadable({
  loader: () =>
    retry(
      () =>
        import(
          /* webpackChunkName: "InternalLinkingPage" */ '@rover/react-lib/src/pages/landing/InternalLinking/InternalLinkingPageContainer'
        )
    ),
  loading: Loading,
});

const routes: Route[] = [
  ...INTERNAL_LINKING_REGEX_FOR_REACT_ROUTER.map((path) => ({
    path,
    component: InternalLinkingPage,
    componentName: 'InternalLinkingPage',
    pageName: 'internal-linking',
    pageCategory: 'ssr-internal-linking',
    cacheTag: ['page-internal-linking'],
    concept: CONCEPTS.marketing.growth,
    isReactQueryRoute: false,
  })),
  ...SERVICE_LANDING_REGEX_FOR_REACT_ROUTER.map((path) => ({
    path,
    component: ServiceLandingPage,
    componentName: 'ServiceLandingPage',
    pageName: 'service-landing',
    pageCategory: 'ssr-service-landing',
    cacheTag: ['page-service-landing'],
    concept: CONCEPTS.marketing.growth,
    isReactQueryRoute: true,
  })),
].map((route) => ({
  ...route,
  footerTheme: FooterTheme.LIGHT,
  navBarIsFullWidth: false,
  exact: true,
  suppressLanguagePicker: true,
  cacheTag: [...route.cacheTag, 'page-landing', 'page-all'],
  enableEdgeCache: true,
}));

export default routes;
